import { Box, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import ThresholdList from "./ThresholdSettingList";

const useStyles = makeStyles({
	settingTopBox: {
		display: 'flex',
		flexDirection: 'column',
	},
	settingTab: {
	},
	settingBody: {
		flexGrow: 1,
		marginTop: '-1px',
		border: '1px solid #a7a7a7',
		overflow: 'hidden',
	},
});

export function ThresholdSettingBox() {
	const classes = useStyles();

	return (
		<div className={clsx(classes.settingTopBox)} style={{ height: '100%' }}>
			<Box className={classes.settingBody}>
				<ThresholdList />
			</Box>
		</div>
	);
}
